import React from 'react';
import { LIVE_VISITORS, RECENT_VISITORS, TRK_FEED } from '../../constants';

export default function TrackingScreen() {
  return (
    <div style={{ flex: 1, overflowY: 'auto' }}>
      <div style={{ padding: '20px 24px', maxWidth: '1100px', margin: '0 auto' }}>
        {/* Top bar */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
          <div>
            <div style={{ fontSize: '20px', fontWeight: '800', color: 'var(--navy)' }}>Live Tracking</div>
            <div style={{ fontSize: '12px', color: 'var(--text3)' }}>Real-time activity across all playbooks & collaterals</div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 14px', borderRadius: '20px', background: '#F0FFF4', border: '1px solid #9AE6B4', fontSize: '12px', fontWeight: '700', color: '#276749' }}>
              <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22C55E', display: 'inline-block', animation: 'pulse 2s infinite' }} />
              {LIVE_VISITORS.length} viewing now
            </span>
            <button style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '7px 12px', borderRadius: '8px', border: '1.5px solid var(--border2)', background: 'white', fontFamily: 'inherit', fontSize: '12px', cursor: 'pointer', color: 'var(--text2)' }}>
              <i className="ti ti-bell" /> Alerts
            </button>
          </div>
        </div>

        {/* KPI strip */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '12px', marginBottom: '20px' }}>
          {[
            { ico: 'ti-radio',           color: '#22C55E', bg: '#F0FFF4', val: LIVE_VISITORS.length, label: 'Live now'     },
            { ico: 'ti-eye',             color: '#C8973A', bg: '#FDF4E7', val: 47,                   label: 'Views today'  },
            { ico: 'ti-clock',           color: '#1E4E8C', bg: '#EBF8FF', val: '4:32',               label: 'Avg time'     },
            { ico: 'ti-alert-triangle',  color: '#C53030', bg: '#FFF5F5', val: 3,                    label: 'Drop-offs'    },
          ].map(k => (
            <div key={k.label} style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', padding: '14px 16px', display: 'flex', gap: '12px', alignItems: 'center' }}>
              <div style={{ width: '36px', height: '36px', borderRadius: '9px', background: k.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className={`ti ${k.ico}`} style={{ color: k.color, fontSize: '18px' }} />
              </div>
              <div>
                <div style={{ fontSize: '22px', fontWeight: '800', color: 'var(--navy)', lineHeight: 1 }}>{k.val}</div>
                <div style={{ fontSize: '10px', color: 'var(--text3)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '.05em' }}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Main grid */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
          {/* Visitors column */}
          <div>
            {/* Live visitors */}
            <div style={{ marginBottom: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '13px', fontWeight: '700', color: 'var(--navy)', marginBottom: '10px' }}>
                <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22C55E', display: 'inline-block' }} />
                Live visitors
                <span style={{ fontSize: '11px', color: 'var(--text3)', fontWeight: '400' }}>{LIVE_VISITORS.length} active</span>
              </div>
              {LIVE_VISITORS.map((v, i) => (
                <div key={i} style={{ background: 'white', border: '1.5px solid #9AE6B4', borderRadius: '12px', padding: '12px 14px', marginBottom: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <div style={{ width: '34px', height: '34px', borderRadius: '50%', background: 'var(--navy)', color: '#C8973A', fontSize: '11px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, position: 'relative' }}>
                      {v.ini}
                      <span style={{ position: 'absolute', bottom: '-1px', right: '-1px', width: '10px', height: '10px', borderRadius: '50%', background: '#22C55E', border: '1.5px solid white' }} />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)' }}>{v.name}</div>
                      <div style={{ fontSize: '10px', color: 'var(--text3)' }}>{v.org}</div>
                    </div>
                    <span style={{ fontSize: '10px', fontWeight: '700', padding: '2px 8px', borderRadius: '20px', background: '#F0FFF4', color: '#276749', border: '1px solid #9AE6B4' }}>Live</span>
                  </div>
                  <div style={{ fontSize: '11px', color: 'var(--text2)', marginBottom: '6px' }}>
                    📄 {v.coll} — Page {v.page}/{v.totalPages}
                  </div>
                  <div style={{ display: 'flex', gap: '10px', fontSize: '10px', color: 'var(--text3)' }}>
                    <span>⏱ {v.timeOnPage} on page</span>
                    <span>Total: {v.totalTime}</span>
                    <span>📱 {v.device}</span>
                  </div>
                  {/* Page progress */}
                  <div style={{ display: 'flex', gap: '3px', marginTop: '8px' }}>
                    {Array.from({ length: v.totalPages }, (_, j) => (
                      <div key={j} style={{ flex: 1, height: '4px', borderRadius: '2px', background: v.pagesVisited.includes(j + 1) ? (j + 1 === v.page ? '#22C55E' : '#C8973A') : 'var(--border)' }} />
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Recent visitors */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '13px', fontWeight: '700', color: 'var(--navy)', marginBottom: '10px' }}>
                <i className="ti ti-clock-hour-4" style={{ fontSize: '14px', color: 'var(--text3)' }} />
                Recent (last 2 hrs)
              </div>
              {RECENT_VISITORS.map((v, i) => (
                <div key={i} style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', padding: '12px 14px', marginBottom: '8px', opacity: .85 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: 'var(--surface)', color: 'var(--text2)', fontSize: '10px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, border: '1.5px solid var(--border)' }}>{v.ini}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: '12px', fontWeight: '600', color: 'var(--navy)' }}>{v.name} <span style={{ fontWeight: '400', color: 'var(--text3)' }}>· {v.org}</span></div>
                      <div style={{ fontSize: '10px', color: 'var(--text3)' }}>{v.coll} · {v.totalTime} total · {v.lastSeen}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Feed column */}
          <div>
            <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '7px' }}>
              <i className="ti ti-activity" style={{ fontSize: '14px', color: 'var(--text3)' }} />
              Live feed
            </div>
            <div style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', overflow: 'hidden' }}>
              {TRK_FEED.map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '12px 14px', borderBottom: i < TRK_FEED.length - 1 ? '1px solid var(--border)' : undefined }}>
                  <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: item.dot, flexShrink: 0, marginTop: '4px' }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '12px', color: 'var(--text2)', lineHeight: 1.5 }} dangerouslySetInnerHTML={{ __html: item.text }} />
                    <div style={{ fontSize: '10px', color: 'var(--text3)', marginTop: '2px' }}>{item.time}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
